import { useState } from 'react';

const SubscriptionCard = ({price, bestDeal = false, save = 0, title = "", onClick, isSelected = false}) => {
    const cardClick = (e) => {
        let selected = document.querySelector('.subscription-card-container.selected');
        if (selected) {
            selected.classList.remove('selected');
        }
        e.target.closest('.subscription-card-container').classList.add('selected');
        onClick(price);
    }
    return (
        <div className={`subscription-card-container ${isSelected && 'selected'}`} onClick={cardClick}>
            {bestDeal && (
                <div className="recommended">
                    Recommended
                </div>
            )}
            <div className="subscription-card">
                <div className="subscription-title">
                    {title}
                </div>
                <div className="flex f-row gap-5 f-center subscription-price-container">
                    <div className="subscription-price">
                        ${(price.amount / 100).toFixed(2)}
                    </div>
                    <div>/</div>
                    <div>
                        {price.interval}
                    </div>
                </div>
                {!!save ? (
                    <div className="save-container">
                        Save ${(save / 100).toFixed(2)}/year
                    </div>
                ) : (
                    <div className="yearly-container">
                        ${(price.amount * 12 / 100).toFixed(2)}/year
                    </div>
                )}
            </div>
        </div>
    );
}

export default SubscriptionCard;